import { polygon } from '@turf/turf';
import { Position } from 'geojson';
import { getLargestPolygonFromMultiPolygon } from 'utils/gis';

export const areMultiPolygonCoordinates = (
  coordinates: Position[][] | Position[][][],
): coordinates is Position[][][] => {
  return Array.isArray(coordinates[0][0][0]);
};

export const coordinatesToPolygon = (coordinates: Position[][] | Position[][][]) => {
  let polygonCoordinates: Position[][];

  if (areMultiPolygonCoordinates(coordinates)) {
    const result = getLargestPolygonFromMultiPolygon(coordinates);

    if (result.isOk()) {
      polygonCoordinates = result.value;
    } else {
      polygonCoordinates = coordinates[0];
    }
  } else {
    polygonCoordinates = coordinates;
  }

  return polygon(polygonCoordinates);
};
